// Runs on the home page only -- ../index.js calls initHome() when the path matches.
//
// Everything here is specific to the home page: the two cables.gl WebGL patches
// (hero scene + panda head) and the statement pixel-wipe. Shared behaviour lives
// in ../modules and runs on every page via ./global.js.
import { scrollProgressTracker } from '../modules/scroll-progress.js';
import { initScrollReveal } from '../modules/scroll-reveal.js';

export function initHome() {
  //overide for up and down keys
  window.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
      }
    },
    { passive: false },
  );

  // disable rubberband effect on mobile devices
  document.getElementById('glcanvas')?.addEventListener(
    'touchmove',
    (e) => {
      e.preventDefault();
    },
    false,
  );
/*
  function patchInitialized(patch) {
    // You can now access the patch object (patch), register variable watchers and so on
  }

  function patchFinishedLoading(patch) {
    // The patch is ready now, all assets have been loaded
    // console.log(patch)
    let progressDiv1 = 0;
    scrollProgressTracker.trackScrollProgress(['.hero-statement'], (progress) => {
      progressDiv1 = progress * 5 - 1;
      hero.setVariable('scrollSection', progressDiv1);

      // console.log(progressDiv1);
      // console.log('Progress of #slider ', progressDiv1*4);
    });

    let terminal = hero.getVar('terminal-action');

    if (terminal._v === 'contact-open') {
      contactLink();
    }
  }
  let hero, headAnim;
  document.addEventListener(
    'CABLES.jsLoaded',
    function (event) {
      if (!document.getElementById('glcanvas')) return;
      hero = new CABLES.Patch({
        patchFile: 'https://d2my2wpsc41l6t.cloudfront.net/tdp26/js/TDP_26.gz.json',
        glCanvasId: 'glcanvas',
        glCanvasResizeToWindow: true,
        onPatchLoaded: patchInitialized,
        onFinishedLoading: patchFinishedLoading,
        canvas: { alpha: true, premultipliedAlpha: true },
      });
      //panda head
      headAnim = new CABLES.Patch({
        patchFile: 'https://d2my2wpsc41l6t.cloudfront.net/tdp26/js/Panda_head.gz.json',
        glCanvasId: 'panda-head',
        // glCanvasResizeToWindow: true,
        onFinishedLoading: function () {
          document.getElementById('panda-head').classList.add('start');
          const el = document.getElementById('logo-mark');
          let mouseX = 0;
          let mouseY = 0;
          let frame;

          window.addEventListener(
            'pointermove',
            (e) => {
              mouseX = (e.clientX / window.innerWidth) * 2 - 1;
              mouseY = -1 * ((e.clientY / window.innerHeight) * 2 - 1);

              if (frame) return;

              frame = requestAnimationFrame(() => {
                headAnim.setVarValue('mouseX', mouseX);
                headAnim.setVarValue('mouseY', mouseY);

                frame = null;
              });
            },
            { passive: true },
          );
          el.addEventListener('mouseenter', () => {
            headAnim.setVarValue('start', 1);
            setTimeout(() => {
              headAnim.setVarValue('start', 0);
            }, 7000);
          });
        },
        canvas: { alpha: true, premultipliedAlpha: true },
      });
    },
    { once: true },
  );
  
  function contactLink() {
    const mailLink = document.querySelector('.is-mail a');
    if (mailLink) {
      window.location.href = mailLink.getAttribute('href');
    }
  }
  */

  // Statement pixel-wipe reveal.
  var wipeMobile = window.matchMedia('(max-width: 767px)').matches;
  initScrollReveal(
    Object.assign(
      {
        track: '.statement--wrapper',
        stage: '.statement--wrapper',
        start: '20% top',
        end: 'bottom top',
        scrub: 1,
      },
      {
        sheet: 'https://d2my2wpsc41l6t.cloudfront.net/tdp26/images/pixel-transition-v3.avif',
        cols: 6,
        rows: 5,
      },
      // wipeMobile
      //   ? { sheet: 'https://d2my2wpsc41l6t.cloudfront.net/tdp26/images/pixel-transition-v3-mobile.avif',
      //       cols: 6, rows: 4 }
      //   : { sheet: 'https://d2my2wpsc41l6t.cloudfront.net/tdp26/images/pixel-transition-v3.avif',
      //       cols: 6, rows: 5 }
    ),
  ).catch(function (err) {
    console.error('scroll-reveal:', err);
  });
}
